module.exports = __webpack_public_path__ + "img/projectAdvantage-lazy.d6bbc70e.png";